import backgroundGrid from "images/Studio/studio-grid.png";

export const GRID_BACKGROUND = `#fbfbfb url(${backgroundGrid}) repeat fixed 0 0 / 30px auto`;

export const CANVAS_CONTENT_WIDTH = 767;
export const VIDEO_PREVIEW_HEIGHT = 260;

export const FIXED_APP_HEADER_Z_INDEX = 6;
export const ACTION_BAR_Z_INDEX = 5;
export const ABOVE_HEADER_FADE_Z_INDEX = 3;
export const HEADER_FADE_Z_INDEX = 2;
export const BELOW_HEADER_FADE_Z_INDEX = 1;
